/**
 * QRMaps Design System - Geolocation Button Styled Component
 *
 * Map-specific geolocation button with responsive positioning
 */

import styled from 'styled-components';
import { StyledButton } from '../Button/Button.styled';
import { respondTo } from '../../utils/styled';

export const StyledGeolocationButton = styled(StyledButton)`
  /* Positioning */
  position: absolute;
  z-index: ${({ theme }) => theme.zIndex.mapControls};

  /* Mobile positioning */
  ${({ $isMobile, $sidebarHeight, $offsetBottom, theme }) =>
    $isMobile && `
      bottom: calc(${$sidebarHeight || '0px'} + ${theme.spacing.lg} + ${$offsetBottom || '0px'});
      right: ${theme.spacing[2]};
    `
  }

  /* Desktop positioning */
  ${({ $isMobile, $sidebarWidth, $offsetBottom, theme }) =>
    !$isMobile && `
      bottom: calc(${theme.spacing[6]} + ${$offsetBottom || '0px'});
      right: calc(${$sidebarWidth || '0px'} + ${theme.spacing.lg});
    `
  }

  /* Ensure it's always visible */
  ${respondTo.mobile`
    right: ${({ theme }) => theme.spacing[2]};
  `}
`;
